import { render, staticRenderFns } from "./Xunfei.vue?vue&type=template&id=03389cec&scoped=true"
import script from "./Xunfei.vue?vue&type=script&lang=js"
export * from "./Xunfei.vue?vue&type=script&lang=js"
import style0 from "./Xunfei.vue?vue&type=style&index=0&id=03389cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03389cec",
  null
  
)

export default component.exports